import AdditionalInformation from "./AdditionalInformation"
import AgreementOverview from "./AgreementOverview"
import DocusealSigningForm from "./DocusealSigningForm"
import InsuranceAndRegistration from "./InsuranceAndRegistration"
import SelectPaymentMethod from "./SelectPaymentMethod"
import SignAgreement from "./SignAgreement"
import SignAndComplete from "./SignAndComplete"
import ViewContractDetails from "./ViewContractDetails"
import { evaluateAdditionalStep } from "./additionalStepValidation"
import { evaluateRequiredStep } from "./requiredStepValidation"

export { evaluateRequiredStep } from "./requiredStepValidation"

const ReviewStep = (agreementOverview) => ({
  title: "Review",
  key: "review",
  validate: (state) => state.contractDetailsSeen,
  component: agreementOverview ? AgreementOverview : ViewContractDetails,
})

const PayStep = {
  title: "Payment Method",
  key: "pay",
  validate: (state) => {
    if (state.paymentMethod === "manual" || state.paymentType === "manual") {
      return state.paymentType === "manual" && state.paymentMethod === "manual"
    }
    return (
      state.paymentMethod !== "" &&
      state.paymentMethod !== "add" &&
      state.paymentType === "credit"
    )
  },
  component: SelectPaymentMethod,
}

const InsuranceAndRegistrationStep = (quote, agreementOverview) => ({
  title: "Insurance & Registration",
  key: "required",
  validate: (state) =>
    evaluateRequiredStep(state, quote, { includePhone: !agreementOverview })
      .valid,
  component: InsuranceAndRegistration,
})

const AdditionalInformationStep = (quote, agreementOverview) => ({
  title: "Additional Information",
  key: "additional",
  validate: (state) =>
    evaluateAdditionalStep(state, quote, { includePhone: agreementOverview })
      .valid,
  component: AdditionalInformation,
})

const SignAndCompleteStep = {
  title: "Sign & Complete",
  key: "sign",
  validate: (state) => {
    const { signature, dockwaTermsAccepted, marinaTermsAccepted } = state
    return signature !== "" && dockwaTermsAccepted && marinaTermsAccepted
  },
  component: SignAndComplete,
}

const DocusealSignAgreementStep = {
  title: "Sign Agreement",
  key: "sign",
  validate: (state) =>
    state.docusealFormCompleted || state.docusealFormSubmitted || false,
  component: DocusealSigningForm,
}

const SignAgreementStep = {
  title: "Sign Agreement",
  key: "sign",
  validate: (state) => state.reviewReady,
  component: SignAgreement,
}

const shouldShowInsuranceAndRegistrationStep = (quote, agreementOverview) => {
  const { registrationRequired, insuranceRequired, phoneInvalid } = quote

  return (
    registrationRequired ||
    insuranceRequired ||
    (!agreementOverview && phoneInvalid)
  )
}

const shouldShowAdditionalInformationStep = (quote, agreementOverview) => {
  const { contractSigningEnablements, phoneInvalid } = quote
  const hasMarinaFields =
    contractSigningEnablements && contractSigningEnablements.length > 0

  return hasMarinaFields || Boolean(agreementOverview && phoneInvalid)
}

const getSteps = (quote, withTemplate, agreementOverview) => {
  const steps = [ReviewStep(agreementOverview), PayStep]

  if (shouldShowInsuranceAndRegistrationStep(quote, agreementOverview)) {
    steps.push(InsuranceAndRegistrationStep(quote, agreementOverview))
  }

  if (shouldShowAdditionalInformationStep(quote, agreementOverview)) {
    steps.push(AdditionalInformationStep(quote, agreementOverview))
  }

  if (withTemplate) {
    steps.push(
      agreementOverview ? SignAgreementStep : DocusealSignAgreementStep
    )
  } else {
    steps.push(SignAndCompleteStep)
  }

  return steps
}

export default getSteps
